/* Dabi Deri — sepet çekmecesi davranışları (snippets/cart-drawer.liquid).
   Craft'ın cart-drawer.js / cart.js akışına dokunmaz; çekmece her yeniden çizildiğinde
   (sepete ekle, adet, kaldır) MutationObserver ile parçaları yeniden bağlar:
   - öneri şeridi (Shopify önerileri + yedek koleksiyon; sepettekiler çıkarılır, önbellekli)
   - boş sepette son baktıklarınız (localStorage dabi-recent)
   - not / hediye / indirim kodu panelleri (açık panel yeniden çizimde korunur)
   - indirim kodu: /cart/update.js { discount } ile uygulanır, sonuç Liquid'den çizilir
   - hediye: sepet özelliği (Hediye, Hediye notu)
   - favorilere taşı (localStorage dabi-favs) ve kaldırılan ürün için "Geri al"
   - ücretsiz kargo çubuğu eski değerden yeni değere akar
   - tahmini kargoya veriliş tarihi (iş günü; hafta sonu sayılmaz) */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  // sepet sayfasında kök <cart-items data-dcart-page>, aksi hâlde çekmece
  const pageRoot = () => document.querySelector('[data-dcart-page]');
  const SECTIONS = () => (pageRoot() ? ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'] : ['cart-drawer', 'cart-icon-bubble']);
  const isOpen = (d) => !!d && (d.hasAttribute('data-dcart-page') || d.classList.contains('active'));
  const read = (k) => { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } };
  const write = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* depolama yok */ } };
  const drawer = () => pageRoot() || document.querySelector('cart-drawer[data-dcart]');
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  let openPanel = null;
  let lastPct = null;
  const recCache = new Map();
  const miniCache = new Map();

  /* ---------- çekmeceyi bölüm çıktısıyla yeniden çiz ---------- */
  const paint = (sections) => {
    const d = drawer();
    if (!d || !sections) return;
    if (sections['main-cart-items'] || sections['main-cart-footer']) {
      ['main-cart-items', 'main-cart-footer'].forEach((id) => {
        if (!sections[id]) return;
        const src = parse(sections[id]).querySelector('.js-contents');
        const dst = document.getElementById(id)?.querySelector('.js-contents');
        if (src && dst) dst.innerHTML = src.innerHTML;
      });
      const doc = parse(sections['main-cart-items'] || '');
      const empty = !!doc.querySelector('cart-items.is-empty');
      document.querySelector('[data-dcart-page]')?.classList.toggle('is-empty', empty);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', empty);
      if (empty) window.location.reload();
    }
    if (sections['cart-drawer']) {
      const doc = parse(sections['cart-drawer']);
      const src = doc.querySelector('.drawer__inner');
      const dst = d.querySelector('.drawer__inner');
      if (src && dst) dst.innerHTML = src.innerHTML;
      d.classList.toggle('is-empty', !!doc.querySelector('cart-drawer.is-empty'));
    }
    if (sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const src = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (bubble && src) bubble.innerHTML = src.innerHTML;
    }
  };

  const post = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: SECTIONS(), sections_url: window.location.pathname }),
    }).then((r) => r.json().then((j) => (r.ok ? j : Promise.reject(j))));

  // indirim kodları Liquid'de güvenilir gelmiyor; sepet JSON'undan (discount_codes) çizilir
  let codes = null;
  let codesAt = 0;
  const loadCodes = () => fetch(`${root}cart.js`).then((r) => r.json()).then((cart) => { codes = cart.discount_codes || []; codesAt = Date.now(); return codes; });
  const updateCart = (body) => post(`${root}cart/update.js`, body).then((cart) => {
    codes = cart.discount_codes || [];
    codesAt = Date.now();
    paint(cart.sections);
    return cart;
  });

  const addItems = (items) =>
    post(`${root}cart/add.js`, { items }).then((res) => {
      paint(res.sections);
      const d = drawer();
      if (d && !d.classList.contains('active') && typeof d.open === 'function') d.open();
      return res;
    });

  /* ---------- kısa bildirim (Geri al) ---------- */
  let toastTimer = null;
  const toast = (text, action) => {
    const d = drawer();
    if (!d) return;
    let el = d.querySelector(':scope > .dcart-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'dcart-toast';
      el.setAttribute('role', 'status');
      d.appendChild(el);
    }
    el.innerHTML = '';
    const span = document.createElement('span');
    span.textContent = text;
    el.appendChild(span);
    if (action) {
      const b = document.createElement('button');
      b.type = 'button';
      b.textContent = action.label;
      b.addEventListener('click', () => { hide(); action.run(); });
      el.appendChild(b);
    }
    const hide = () => { el.classList.remove('is-on'); };
    setTimeout(() => el.classList.add('is-on'), 20);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hide, 7000);
  };

  /* ---------- öneri şeridi ---------- */
  const fillTrack = (wrap, html) => {
    const track = wrap.querySelector('[data-dcart-recs-track]');
    if (!track) return;
    if (!html) { wrap.hidden = true; return; }
    track.innerHTML = html;
    wrap.hidden = false;
    if (window.DabiStrips) window.DabiStrips.init(wrap);
  };

  const hydrateRecs = (d) => {
    // öneriler yalnız çekmece açıkken yüklenir (her sayfa açılışında istek atılmaz)
    if (!isOpen(d)) return;
    d.querySelectorAll('[data-dcart-recs]:not([data-ready])').forEach((wrap) => {
      wrap.setAttribute('data-ready', '');
      const pid = wrap.dataset.productId;
      if (!pid) return;
      const exclude = new Set((wrap.dataset.exclude || '').split(',').filter(Boolean));
      const limit = parseInt(wrap.dataset.limit, 10) || 6;
      const key = `${pid}|${wrap.dataset.exclude}|${limit}`;
      if (recCache.has(key)) { fillTrack(wrap, recCache.get(key)); return; }
      const url = `${root}recommendations/products?section_id=dabi-cart-recs&product_id=${pid}&limit=${Math.min(limit + 6, 10)}&intent=${wrap.dataset.intent || 'related'}`;
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const seen = new Set();
          const out = [];
          parse(html).querySelectorAll('[data-dcart-mini]').forEach((card) => {
            const id = card.dataset.productId;
            if (exclude.has(id) || seen.has(id) || out.length >= limit) return;
            seen.add(id);
            out.push(card.outerHTML);
          });
          const res = out.join('');
          recCache.set(key, res);
          if (wrap.isConnected) fillTrack(wrap, res);
        })
        .catch(() => { wrap.hidden = true; });
    });

    d.querySelectorAll('[data-dcart-recent]:not([data-ready])').forEach((wrap) => {
      wrap.setAttribute('data-ready', '');
      const limit = parseInt(wrap.dataset.limit, 10) || 6;
      const handles = read('dabi-recent').slice(0, limit);
      if (handles.length === 0) return;
      Promise.all(
        handles.map((h) => {
          if (miniCache.has(h)) return Promise.resolve(miniCache.get(h));
          return fetch(`${root}products/${encodeURIComponent(h)}?section_id=dabi-cart-recs`)
            .then((r) => (r.ok ? r.text() : ''))
            .then((html) => {
              const card = html ? parse(html).querySelector('[data-dcart-mini]') : null;
              const out = card ? card.outerHTML : '';
              miniCache.set(h, out);
              return out;
            })
            .catch(() => '');
        }),
      ).then((parts) => {
        const html = parts.join('');
        if (!wrap.isConnected || !html) return;
        fillTrack(wrap, html);
        wrap.querySelector('.dcart-recs__track')?.setAttribute('data-dabi-strip-nav', '');
        wrap.querySelector('.dcart-recs__track')?.setAttribute('data-dabi-strip-look', 'slim');
        if (window.DabiStrips) window.DabiStrips.init(wrap);
      });
    });
  };

  /* ---------- panelleri yeniden çizimde koru ---------- */
  // sepet sayfasında paneller ana içerikte (özet sütunu); çekmece gövdede ayrı durur
  const scopeEl = (d) => (d && d.hasAttribute('data-dcart-page') ? (document.getElementById('MainContent') || document) : d);
  const setPanel = (d, name, focus) => {
    openPanel = name;
    scopeEl(d).querySelectorAll('[data-dcart-panel]').forEach((b) => b.setAttribute('aria-expanded', String(b.dataset.dcartPanel === name)));
    scopeEl(d).querySelectorAll('[data-dcart-panel-body]').forEach((p) => { p.hidden = p.dataset.dcartPanelBody !== name; });
    if (focus && name) scopeEl(d).querySelector(`[data-dcart-panel-body="${name}"]`)?.querySelector('textarea, input')?.focus({ preventScroll: true });
  };

  /* ---------- kargo çubuğu: eski değerden akış ---------- */
  const animateShip = (d) => {
    const bar = scopeEl(d).querySelector('.dcart-ship');
    if (!bar || bar.dataset.dcartSeen) return;
    bar.dataset.dcartSeen = '1';
    const target = bar.style.getPropertyValue('--p').trim();
    if (lastPct !== null && lastPct !== target) {
      bar.style.setProperty('--p', lastPct);
      requestAnimationFrame(() => requestAnimationFrame(() => bar.style.setProperty('--p', target)));
      if (bar.classList.contains('is-done') && lastPct !== '100%') bar.classList.add('is-celebrate');
    }
    lastPct = target;
  };

  /* ---------- tahmini kargoya veriliş ---------- */
  const addBusinessDays = (n) => {
    const t = new Date();
    t.setHours(12, 0, 0, 0);
    while (t.getDay() === 0 || t.getDay() === 6) t.setDate(t.getDate() + 1);
    let left = n;
    while (left > 0) {
      t.setDate(t.getDate() + 1);
      if (t.getDay() !== 0 && t.getDay() !== 6) left -= 1;
    }
    return t;
  };
  const hydrateEta = (d) => {
    const el = scopeEl(d).querySelector('[data-dcart-eta]');
    if (!el || !el.hidden) return;
    const min = parseInt(el.dataset.min, 10) || 0;
    const max = Math.max(min, parseInt(el.dataset.max, 10) || 0);
    const lang = document.documentElement.lang || 'tr';
    let fmt;
    try { fmt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short', weekday: 'short' }); } catch (e) { return; }
    const a = addBusinessDays(min);
    const b = addBusinessDays(max);
    let when;
    if (min === max) when = fmt.format(a);
    else if (typeof fmt.formatRange === 'function') when = fmt.formatRange(a, b);
    else when = `${fmt.format(a)} – ${fmt.format(b)}`;
    const text = (el.dataset.text || '{date}').replace('{date}', when);
    const span = el.querySelector('[data-dcart-eta-text]');
    if (span) span.textContent = text;
    el.hidden = false;
  };

  const hydrate = () => {
    const d = drawer();
    if (!d) return;
    hydrateRecs(d);
    hydrateEta(d);
    hydrateCodes(d);
    animateShip(d);
    if (openPanel && scopeEl(d).querySelector(`[data-dcart-panel-body="${openPanel}"]`)) setPanel(d, openPanel, false);
  };

  /* ---------- olaylar ---------- */
  let lastRemoved = null;
  let favMove = false;

  document.addEventListener(
    'click',
    (e) => {
      const d = rootOf(e.target) ? drawer() : null;
      if (!d) return;

      // kaldırılan satırı "Geri al" için hatırla (Craft kaldırma işlemine dokunmadan)
      const rm = e.target.closest('cart-remove-button');
      if (rm) {
        const row = rm.closest('[data-dcart-line]');
        if (row) {
          let props = {};
          try { props = JSON.parse(row.dataset.props || '{}'); } catch (err) { props = {}; }
          lastRemoved = { id: Number(row.dataset.variantId), quantity: Number(row.dataset.qty) || 1, properties: props, title: row.dataset.title };
          if (d.dataset.undo === 'true') {
            const removed = lastRemoved;
            const verb = favMove ? d.dataset.strMoved : d.dataset.strRemoved;
            favMove = false;
            toast(`${removed.title} ${verb || ''}`.trim(), {
              label: d.dataset.strUndo || 'Undo',
              run: () => addItems([{ id: removed.id, quantity: removed.quantity, properties: removed.properties }]).catch(() => toast(d.dataset.strError || '')),
            });
          }
        }
        return;
      }

      // hızlı bakış açılmadan önce çekmeceyi kapat (pencere çekmecenin altında kalmasın)
      if (e.target.closest('[data-dcart-qv]') && typeof d.close === 'function') d.close();
    },
    true,
  );

  const rootOf = (el) => el.closest?.('[data-dcart-page], #main-cart-footer, cart-drawer[data-dcart]');
  document.addEventListener('click', (e) => {
    const d = rootOf(e.target) ? drawer() : null;
    if (!d) return;

    const pb = e.target.closest('[data-dcart-panel]');
    if (pb) {
      const name = pb.dataset.dcartPanel;
      setPanel(d, openPanel === name ? null : name, true);
      return;
    }

    const fav = e.target.closest('[data-dcart-fav]');
    if (fav) {
      const handle = fav.dataset.dcartFav;
      const favs = read('dabi-favs').filter((h) => h !== handle);
      favs.unshift(handle);
      write('dabi-favs', favs.slice(0, 60));
      document.dispatchEvent(new CustomEvent('dabi:favs-change'));
      favMove = true;
      fav.closest('[data-dcart-line]')?.querySelector('cart-remove-button')?.click();
      return;
    }

    const add = e.target.closest('[data-dcart-add]');
    if (add) {
      if (add.disabled) return;
      add.disabled = true;
      add.classList.add('is-busy');
      addItems([{ id: Number(add.dataset.dcartAdd), quantity: 1 }])
        .catch((err) => {
          add.disabled = false;
          add.classList.remove('is-busy');
          toast(err?.description || err?.message || d.dataset.strError || '');
        });
      return;
    }

    const apply = e.target.closest('[data-dcart-code-apply]');
    if (apply) { applyCode(d); return; }

    const rmCode = e.target.closest('[data-dcart-code-remove]');
    if (rmCode) {
      const keep = codeList().filter((c) => c.toUpperCase() !== rmCode.dataset.dcartCodeRemove.toUpperCase());
      openPanel = 'code';
      updateCart({ discount: keep.join(',') }).catch(() => toast(d.dataset.strError || ''));
    }
  });

  /* ---------- indirim kodu ---------- */
  const codeList = () => (codes || []).map((c) => c.code);
  const drawCodes = (d) => {
    const ul = scopeEl(d).querySelector('[data-dcart-code-chips]');
    if (!ul) return;
    const list = codes || [];
    ul.innerHTML = '';
    list.forEach((c) => {
      const li = document.createElement('li');
      li.className = `dcart-codechip${c.applicable ? '' : ' is-bad'}`;
      const span = document.createElement('span');
      span.textContent = c.code;
      const b = document.createElement('button');
      b.type = 'button';
      b.dataset.dcartCodeRemove = c.code;
      b.setAttribute('aria-label', `${ul.dataset.labelRemove || ''}: ${c.code}`);
      b.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" focusable="false"><path d="M7 7l10 10M17 7L7 17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      li.append(span, b);
      ul.appendChild(li);
    });
    ul.hidden = list.length === 0;
    const bad = scopeEl(d).querySelector('[data-dcart-code-bad]');
    if (bad) bad.hidden = !list.some((c) => !c.applicable);
    scopeEl(d).querySelector('[data-dcart-panel="code"]')?.classList.toggle('is-set', list.length > 0);
  };
  const hydrateCodes = (d) => {
    const ul = scopeEl(d).querySelector('[data-dcart-code-chips]:not([data-ready])');
    if (!ul) return;
    ul.setAttribute('data-ready', '');
    // kendi güncellememizden hemen sonra JSON hazır; aksi halde (sepete ekle vb.) taze oku
    if (codes && Date.now() - codesAt < 2000) { drawCodes(d); return; }
    if (!isOpen(d)) { ul.removeAttribute('data-ready'); return; }
    loadCodes().then(() => { if (ul.isConnected) drawCodes(d); }).catch(() => {});
  };
  const applyCode = async (d) => {
    if (!codes) { try { await loadCodes(); } catch (e) { codes = []; } }
    const input = scopeEl(d).querySelector('[data-dcart-code-input]');
    const msg = scopeEl(d).querySelector('[data-dcart-code-msg]');
    const code = (input?.value || '').trim();
    if (!code) { input?.focus(); return; }
    const next = codeList().filter((c) => c.toUpperCase() !== code.toUpperCase());
    next.push(code);
    const btn = scopeEl(d).querySelector('[data-dcart-code-apply]');
    btn?.classList.add('is-busy');
    openPanel = 'code';
    updateCart({ discount: next.join(',') })
      .then(() => { drawer()?.querySelector('[data-dcart-code-input]')?.focus({ preventScroll: true }); })
      .catch((err) => {
        btn?.classList.remove('is-busy');
        if (msg) { msg.textContent = err?.description || err?.message || d.dataset.strError || ''; msg.hidden = false; }
      });
  };
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const input = e.target.closest?.('[data-dcart-code-input]');
    if (!input) return;
    e.preventDefault();
    applyCode(drawer());
  });

  /* ---------- hediye (sepet özelliği; yeniden çizmeden kaydedilir) ---------- */
  let giftTimer = null;
  const saveGift = (d) => {
    const on = !!scopeEl(d).querySelector('[data-dcart-gift]')?.checked;
    const note = scopeEl(d).querySelector('[data-dcart-gift-note]')?.value || '';
    const status = scopeEl(d).querySelector('[data-dcart-gift-status]');
    fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Hediye: on ? 'Evet' : '', 'Hediye notu': on ? note : '' } }),
    })
      .then((r) => { if (!r.ok) throw new Error(); if (status) status.textContent = '✓'; })
      .catch(() => { if (status) status.textContent = d.dataset.strError || ''; });
    scopeEl(d).querySelector('[data-dcart-panel="gift"]')?.classList.toggle('is-set', on);
  };
  document.addEventListener('change', (e) => {
    const g = e.target.closest?.('[data-dcart-gift]');
    if (!g) return;
    const d = drawer();
    const more = scopeEl(d).querySelector('[data-dcart-gift-more]');
    if (more) more.hidden = !g.checked;
    saveGift(d);
  });
  document.addEventListener('input', (e) => {
    if (e.target.closest?.('[data-dcart-gift-note]')) {
      clearTimeout(giftTimer);
      giftTimer = setTimeout(() => saveGift(drawer()), 600);
    }
    if (e.target.closest?.('#CartDrawer-Note')) {
      drawer()?.querySelector('[data-dcart-panel="note"]')?.classList.toggle('is-set', e.target.value.trim() !== '');
    }
  });

  /* ---------- başlat ---------- */
  const boot = () => {
    const d = drawer();
    if (!d || d.dataset.dcartBooted) return;
    d.dataset.dcartBooted = '1';
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      setTimeout(() => { queued = false; hydrate(); }, 30);
    }).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    const foot = document.getElementById('main-cart-footer');
    if (d.hasAttribute('data-dcart-page') && foot) {
      new MutationObserver(() => { if (queued) return; queued = true; setTimeout(() => { queued = false; hydrate(); }, 30); }).observe(foot, { childList: true, subtree: true });
    }
    hydrate();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
